import { Add } from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/joy";
import { ApiCategory } from "griptonite-api-client";
import { useState } from "react";

import { useLeagueQuery } from "@/hooks/competitions";

import { CategoriesList } from "../CompetitionProfile/CompetitionCategories";
import CompetitionCategoryDrawer from "../CompetitionProfile/CompetitionCategoryDrawer";
import BottomButtons from "./BottomButtons";

export default function LeagueCategories({ leagueUuid }: { leagueUuid: string }) {
  const { data: league } = useLeagueQuery(leagueUuid);
  const [sidebarState, setSidebarState] = useState<{
    category: ApiCategory | null;
  } | null>(null);
  return (
    <>
      <Stack flex={1}>
        <Box sx={{ flex: 1, padding: 1.5 }}>
          <CategoriesList
            categories={league?.categories}
            onCategoryClick={(category) => setSidebarState({ category })}
          />
          <Box sx={{ marginTop: 1.5 }}>
            <Button
              startDecorator={<Add />}
              onClick={() =>
                setSidebarState({
                  category: null,
                })
              }
            >
              Add Category
            </Button>
          </Box>
        </Box>

        <Box sx={{ padding: 1.5 }}>
          <BottomButtons
            league={league}
            nextLink={{
              to: "/gym/$venueUuid/events/series/$leagueUuid/profile/scoring",
            }}
            prevLink={{
              to: "/gym/$venueUuid/events/series/$leagueUuid/profile/details",
            }}
          />
        </Box>
      </Stack>
      {/* <Drawer open={sidebarState !== null} anchor="right">

      </Drawer> */}
      <CompetitionCategoryDrawer
        open={sidebarState !== null}
        onClose={() => setSidebarState(null)}
        league={league}
        category={sidebarState?.category ?? undefined}
      />
    </>
  );
}
